import { useContentfulInspectorMode } from "@contentful/live-preview/react";
import * as Tabs from "@radix-ui/react-tabs";

import type { TypeTabs } from "~/contentful/compiled";
import { RichTextRender } from "~/contentful/components/rich-text";
import type { SerializeFrom } from "~/lib/types";
import { cn } from "~/lib/ui";

const PDPTabs = ({
  content,
}: {
  content: SerializeFrom<Array<TypeTabs<"WITHOUT_UNRESOLVABLE_LINKS", string>>>;
}) => {
  const fields = content.map(tab => tab.fields);
  const defaultTab = fields.find(f => f.showTabs);
  const inspectorProps = useContentfulInspectorMode();

  const getEntryId = (fieldId: string) => {
    return content.find(e => e.fields.id === fieldId)?.sys.id;
  };

  return (
    <Tabs.Root
      className="flex w-full flex-col items-center pb-[56px]"
      defaultValue={defaultTab?.id}
    >
      <Tabs.List className="w-full px-[40px]">
        <div
          className={cn(
            "flex items-center justify-center border-b border-b-gray-200",
            !defaultTab && "hidden",
          )}
        >
          {fields.map(
            f =>
              f.showTabs && (
                <span
                  key={f.id}
                  {...inspectorProps({
                    entryId: getEntryId(f.id),
                    fieldId: "name",
                  })}
                >
                  <Tabs.Trigger
                    className="flex h-[40px] cursor-default select-none items-center justify-center bg-transparent px-[16px] text-lg font-bold leading-[26px] text-neutral-12 outline-none data-[state=inactive]:text-neutralalpha-11 data-[state=active]:underline data-[state=active]:decoration-accent-10 data-[state=active]:underline-offset-[11px]"
                    value={f.id}
                  >
                    {f.tabTitle}
                  </Tabs.Trigger>
                </span>
              ),
          )}
        </div>
      </Tabs.List>
      {fields.map(
        f =>
          f.showTabs && (
            <span
              key={f.id}
              {...inspectorProps({
                entryId: getEntryId(f.id),
                fieldId: "name",
              })}
            >
              <Tabs.Content
                className="flex h-[234px] items-start justify-center gap-[24px] self-stretch bg-transparent px-[40px] data-[state=inactive]:hidden sm-max:h-auto"
                value={f.id}
              >
                <div className="text-lg leading-[26px]">
                  <p className="py-[24px] font-bold text-neutral-12">
                    {f.tabContentTitle}
                  </p>
                  <div className="columns-1 gap-[24px] font-light text-neutralalpha-11 sm:columns-2 lg:columns-3">
                    <RichTextRender
                      entryId={getEntryId(f.id) ?? ""}
                      content={f.content}
                    />
                  </div>
                </div>
              </Tabs.Content>
            </span>
          ),
      )}
    </Tabs.Root>
  );
};

export default PDPTabs;
